export const getGoogleDriveDirectLink = (url) => {
  if (!url) return "";
  const fileDMatch = url.match(/drive\.google\.com\/file\/d\/([^/]+)/);
  if (fileDMatch && fileDMatch[1]) {
    return `https://drive.google.com/uc?export=download&id=${fileDMatch[1]}`;
  }
  const openIdMatch = url.match(/drive\.google\.com\/open\?id=([^&]+)/);
  if (openIdMatch && openIdMatch[1]) {
    return `https://drive.google.com/uc?export=download&id=${openIdMatch[1]}`;
  }
  const docsDMatch = url.match(/docs\.google\.com\/file\/d\/([^/]+)/);
  if (docsDMatch && docsDMatch[1]) {
    return `https://drive.google.com/uc?export=download&id=${docsDMatch[1]}`;
  }
  return url;
};

export const getCloudinaryCoverUrl = (pdfUrl) => {
  if (!pdfUrl) return "";
  if (pdfUrl.includes("cloudinary.com")) {
    return pdfUrl.replace(/\.pdf(\?.*)?$/i, ".jpg");
  }
  return "";
};

export const getCloudinaryDownloadUrl = (url) => {
  if (!url) return "";
  if (url.includes("cloudinary.com") && !url.includes("fl_attachment")) {
    return url.replace("/upload/", "/upload/fl_attachment/");
  }
  return url;
};

const PRESET_COLORS = [
  "#2C3E50", // Dark slate
  "#16A085", // Muted teal
  "#27AE60", // Muted green
  "#2980B9", // Muted blue
  "#8E44AD", // Muted purple
  "#D35400", // Muted orange
  "#C0392B", // Muted red
  "#7F8C8D", // Slate gray
  "#8D6E63", // Muted brown
  "#1A5276", // Dark blue
];

export const getBookFallbackColor = (title) => {
  if (!title) return PRESET_COLORS[0];
  let sum = 0;
  for (let i = 0; i < title.length; i++) {
    sum += title.charCodeAt(i);
  }
  return PRESET_COLORS[sum % PRESET_COLORS.length];
};

